import React from "react";
import { Formik, Form as FormikForm } from "formik";
import MuiBox from "@mui/material/Box";
export const Form = ({ name, children, onSubmit, initialValues, ...props }) => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values: any, helpers: any) => {
                if (onSubmit) {
                    onSubmit(values, helpers);
                } else {
                    console.log(name, values);
                }
            }}
            {...props}
        >
          <MuiBox
              component={FormikForm}
              {...props}
          >
            {children}
          </MuiBox>
        </Formik>
    );
};

export default Form;